// extracted by mini-css-extract-plugin
export var highlightFade = "_2x-4";
export var highlighted = "_2x-3";
export var table = "_2x-1";
export var tableContainer = "_2x-0";
export var totalsRow = "_2x-2";